import { type CarrierDef } from '../common.js'
import { slcy, type slcyCredType } from './slcy.js'

export type sncyCredType = slcyCredType
export const sncy: CarrierDef<sncyCredType> = {
  ...slcy,
  scac: 'sncy',
}
